'use client';

import { appDownloadUrl, appendShareParams } from '@repo/config';
import { Link } from '@repo/web-chrome/components/link';
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

const SHOW_AFTER_PX = 600;

export function HomeStickyCta(): React.JSX.Element {
  const t = useTranslations('home.hero');
  const [visible, setVisible] = useState(false);
  const downloadUrl = appendShareParams(appDownloadUrl, {
    source: 'web',
    campaign: 'app_download',
  });

  useEffect(() => {
    const onScroll = (): void => {
      setVisible(window.scrollY > SHOW_AFTER_PX);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return (): void => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      aria-hidden={!visible}
      className={clsx(
        'fixed inset-x-3 bottom-3 z-40 md:hidden',
        'motion-safe:transition-[opacity,transform] motion-safe:duration-300 ease-out-expo',
        visible ? 'opacity-100 translate-y-0' : 'pointer-events-none opacity-0 translate-y-6',
      )}
    >
      <Link
        href={downloadUrl}
        tabIndex={visible ? undefined : -1}
        className="cm-press flex w-full items-center justify-center rounded-2xl bg-gray-950 px-6 py-4 text-base font-semibold text-white shadow-2xl shadow-black/30 ring-1 ring-white/10"
      >
        {t('primaryCtaLabel')}
      </Link>
    </div>
  );
}
